import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { ScreeningActionCompositeEntity, ScreeningActionEntity } from '@nk/data-entities-lib';
import { CardListItemDateComponent, CardListItemTextComponent, NkCardListConfig, NkCardListData } from '@nk/ui-lib';
import { ScreeningActionLatestStatusCardListItemComponent } from '../components/screening-action-latest-status-card-list-item/screening-action-latest-status-card-list-item.component';

export interface ScreeningActionCardListItem {
  uuid: string;
  screeningAction: ScreeningActionEntity;
  appMembershipUuid: string;
  monitoringOriginKey: string;
  decisionTimestamp: Date | null;
  monitoringComment: string;
  data: {
    uuid: string;
    screeningAction: ScreeningActionEntity;
    appMembershipUuid: string;
    monitoringOriginKey: string;
    decisionTimestamp: Date | null;
    monitoringComment: string;
  };
}

export const SCREENING_ACTION_CARD_LIST_CONFIG: NkCardListConfig<ScreeningActionCardListItem> = {
  items: [
    {
      andClass: 'col-sm-3 d-inline-flex justify-content-start align-items-start',
      label: extractTranslation('tables.screening_entity_log.action'),
      prop: 'screeningAction',
      component: ScreeningActionLatestStatusCardListItemComponent,
      sortable: false,
    },
    {
      andClass: 'col-sm-2',
      label: extractTranslation('tables.screening_entity_log.action_by'),
      prop: 'monitoringOriginKey',
      component: CardListItemTextComponent,
      sortable: false,
    },
    {
      andClass: 'col-sm-3',
      label: extractTranslation('tables.screening_entity_log.date'),
      prop: 'decisionTimestamp',
      component: CardListItemDateComponent,
      sortable: false,
    },
    {
      andClass: 'col-sm-4',
      label: extractTranslation('tables.screening_entity_log.reason'),
      prop: 'monitoringComment',
      component: CardListItemTextComponent,
      sortable: false,
    },
  ],
  noDataMessage: extractTranslation('tables.screening_entity_log.history_no_data_found'),
};

export const EMPTY_SCREENING_ACTION_CARD_LIST_DATA: NkCardListData<ScreeningActionCardListItem> = {
  entities: [],
  pagination: { limit: 0, page: 0, totalCount: 0 },
};

export function transformToScreeningActionCardListItems(
  entities: ScreeningActionCompositeEntity[],
): ScreeningActionCardListItem[] {
  return entities.map((entity) => {
    // Format the decision timestamp
    const decisionTimestamp = entity.screening_action?.decision_timestamp
      ? new Date(entity.screening_action.decision_timestamp)
      : null;

    return {
      uuid: entity.uuid,
      screeningAction: entity.screening_action,
      appMembershipUuid: entity.screening_action.app_membership_uuid,
      monitoringOriginKey: entity.screening_action.monitoring_origin_key || '-',
      decisionTimestamp: decisionTimestamp,
      monitoringComment: entity.screening_action.monitoring_comment || '-',
      data: {
        uuid: entity.uuid,
        screeningAction: entity.screening_action,
        appMembershipUuid: entity.screening_action.app_membership_uuid,
        monitoringOriginKey: entity.screening_action.monitoring_origin_key,
        decisionTimestamp: decisionTimestamp,
        monitoringComment: entity.screening_action.monitoring_comment || '-',
      },
    };
  });
}
